<template>
	<div>
		
		<div class="d-flex flex-row mb-4">
			<div class="font-weight-medium pt-0">{{field.name}}</div>
			<v-spacer/>
			<v-btn class="mr-2" style="hheight: 40px;" width="120" small color="secondary" @click="addTableEntry()">
				Add new {{ (field.value.settings.relevantDirection === 'horizontal') ? 'column' : 'row' }}
			</v-btn>
		</div>
		
		<div class="mb-6">

			<!-- We use i-1 (minus one) because Vue v-for starts at 1, and arrays start at 0 -->
			<div class="d-flex flex-row mb-n4" v-for="i in field.value.table.length" :key="i">

				<v-text-field
					v-for="j in field.value.table[i-1].tableEntry.length" :key="j"
					:class="(j-1 > 0) ? 'mx-2' : 'mr-2'"
					v-model.trim="field.value.table[i-1].tableEntry[j-1]"
					outlined
					dense
				></v-text-field>

				<v-btn icon @click="removeTableEntry(i-1);">
					<v-icon>mdi-minus-circle</v-icon>
				</v-btn>
				
			</div>
		</div>
		
		<div v-if="settingsExposed" class="font-weight-medium mt-5">Table settings</div>
		<ViewTableField ref="settingsUi" v-if="settingsExposed" :field="tableSettings" />

	</div>
</template>



<script>


// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

import Vue from 'vue';
import ViewTableField from '@/components/viewseditor/fieldtypes/ViewTableField';

export default
{
	name: 'ContentFieldTable',
	components: { ViewTableField },

	// ----------------------------------
	//	VUE: Data, properties, etc.
	// ----------------------------------

	props:
	{
		field: { type: Object },
	},

	data: () =>
	({
		settingsExposed: false,
		tableSettings: {},
		dataToAddTable: [],
	}),

	watch:
	{
		'field.value.settings.rowOrCols'()
		{
			this.syncTable();
		},

		'tableSettings.settings.rowOrCols'()
		{
			this.syncTable();
		},
	},


	// ----------------------------------------------------
	//
	//  VUE: Create and Mount
	//
	// ----------------------------------------------------

	created()
	{

		// -------------------------------------------------
		//	Some ui setup
		// -------------------------------------------------
		
		this.settingsExposed = this.field.template.typeProperties.showInEditor;
		
		
		// -------------------------------------------------
		//	Do we have already saved data? Or set defaults?
		// -------------------------------------------------
		
		// First, create the new object with template dafault settings, regardless of if we have existing saved settings
		// The reason for this, is that we might have added new settings properties in the template. We will overwrite
		// settings the specific default settings with saved ones, we we have saved settings from the database.
		
		this.field.value = Vue.observable({ table: [], settings: Vue.observable(Object.assign({}, this.field.template.typeProperties)) });

		// Do we have existing data?
		if (this.field.data)
		{
			// Table existing datasettings
			if (this.field.data.table)
			{
				this.field.value.table = this.field.data.table;
			}
			// Table settings
			if (this.field.data.settings)
			{
				// Now, overwrite each individual setting with existing settings!
				for (const property in this.field.value.settings)
				{
					this.field.value.settings[property] = this.field.data.settings[property];
				}
			}
		}

		// Now, set the aactual dataprovider for the settings separately here, because it needs to be wrapped in 'typeProperties'.
		this.tableSettings = Vue.observable({ typeProperties: Vue.observable(this.field.value.settings) });
		
		//console.log(this.field.value.settings.rowOrCols);
		this.field.value.settings.rowOrCols = Vue.observable(this.field.value.settings.rowOrCols);
		//console.log(this.field.value.settings.rowOrCols);
	},

	mounted()
	{
		if (this.settingsExposed) this.$refs.settingsUi.$refs.exposeToEditor.$el.style.display = 'none';
	},


	// ----------------------------------------------------
	//
	//  VUE: Methods
	//
	// ----------------------------------------------------

	methods:
	{
		addTableEntry()
		{
			
			let tableEntry = new Array(this.field.value.settings.rowOrCols);

			for (let i = 0; i < tableEntry.length; i++)
			{
				tableEntry[i] = "";
			}

			this.field.value.table.push( { tableEntry: tableEntry } );
			this.syncTable();
		},



		removeTableEntry(i)
		{
			this.field.value.table.splice(i, 1);
		},



		syncTable()
		{
			
			const rowOrCols = this.field.value.settings.rowOrCols;
			if (!rowOrCols) return;
			
			for (let i = 0; i < this.field.value.table.length; i++)
			{
				const tableEntry = this.field.value.table[i].tableEntry;
				
				if (rowOrCols < tableEntry.length)
				{
					// Updated row/col count is lower than existing, delete entries
					tableEntry.splice(rowOrCols, tableEntry.length-rowOrCols);
				}
				else if (rowOrCols > tableEntry.length)
				{
					// Updated row/col count is higher than existing, add empty entries
					for (let j = 0; j < rowOrCols; j++)
					{
						if (j > tableEntry.length-1) tableEntry.push('');
					}
				}

			}
		},



	}

}

</script>

